import React from "react";
import { Row, Col } from "antd";
import { Carousel as AntCarousel } from "antd";
import styled from "styled-components";
import { device } from "../globalAssets/breakpoints";
import { desktop, mobile } from "../globalAssets/fontsize";
import AuthImage1 from "../assets/authImg1.jpg";
import AuthImage2 from "../assets/authImg2.jpg";
import AuthImage3 from "../assets/authImg3.jpg";
import DarkLogo from "../assets/atlasLogoDark.png";
import LightLogo from "../assets/atlasLogoLight.png";
import { useAppSelector } from "../app/hooks";

import { DarkModeToggler } from "./DarkmodeToggler";
import { mode } from "./slice/modeSlice";

export const AuthenticationLayout: React.FC<React.ReactNode> = ({
  children,
}) => {
  const lightmode = useAppSelector(mode);

  return (
    <Row style={{ height: "100vh" }}>
      <Col sm={{ span: 0 }} lg={{ span: 13 }}>
        <Carousel />
      </Col>
      <Col xs={{ span: 24 }} lg={{ span: 11 }}>
        <ModeTogglerPosition>
          <DarkModeToggler />
        </ModeTogglerPosition>
        <LogoContainer src={lightmode === "light" ? LightLogo : DarkLogo} />

        <ChildrenContainer>{children}</ChildrenContainer>
      </Col>
    </Row>
  );
};

const Carousel = () => {
  return (
    <CarouselContainer>
      <StyledCarousel
        autoplay
        speed={2000}
        infinite={true}
        style={{ margin: 0, padding: 0 }}
        effect="fade"
      >
        <ImageWrapper>
          <TextPosition>Get started on your Journey of DREAMS</TextPosition>
          <CarouselImage authImage={AuthImage2} />
        </ImageWrapper>
        <ImageWrapper>
          <TextPosition>Accomodation at the tip of your finger</TextPosition>
          <CarouselImage authImage={AuthImage1} />
        </ImageWrapper>
        <ImageWrapper>
          <TextPosition>Locate people and places on the map</TextPosition>
          <CarouselImage authImage={AuthImage3} />
        </ImageWrapper>
      </StyledCarousel>
    </CarouselContainer>
  );
};

const LogoContainer = styled.img`
  position: absolute;
  height: 20px;
  right: 15px;
  top: 2%;
  @media ${device.laptop} {
    height: 2vw;
    position: absolute;
    top: 3%;
    right: 15%;
  }
`;

const ModeTogglerPosition = styled.div`
  position: absolute;
  top: 2%;
  left: 15px;
  z-index: 10;
  @media ${device.desktop} {
    position: absolute;
    height: 2vw;
    top: 3%;
    left: 15%;
  }
`;

const ChildrenContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 40px 15px;
  & > div {
    width: 100%;
  }
  & > div > h3 {
    color: ${(props) => props.theme.color};
    font-size: ${mobile.large};
  }
  @media ${device.laptop} {
    padding: 3% 15%;

    & > div > h3 {
      font-size: ${desktop.large};
    }
  }
`;

interface ImageProp {
  authImage: string;
}

const CarouselContainer = styled.div`
  display: none;
  @media ${device.laptop} {
    display: block;
  }
`;
const ImageWrapper = styled.div`
  display: none;
  @media ${device.laptop} {
    display: block;
    width: 100%;
    height: 100vh;
    border: none;
    padding: none;
    margin: none;
  }
`;
const TextPosition = styled.div`
  position: absolute;
  left: 5vw;
  width: 60%;
  bottom: 30%;
  color: ${(props) => props.theme.white};
  font-size: ${desktop.large};
  font-weight: 500;
  padding: 0;
  margin: 0;
`;
const CarouselImage = styled.img<ImageProp>`
  display: none;
  @media ${device.laptop} {
    display: block;
    border: none;
    width: 100%;
    height: 100%;
    background: ${(props) =>
      `linear-gradient(rgba(16,171,222,0),rgba(0,116,255,0.5)),url(${props.authImage})`};
    background-position: right;
  }
`;
const StyledCarousel = styled(AntCarousel)`
  display: none;
  @media ${device.laptop} {
    display: block;
  }
`;
